<template>
  <div v-show="opportunityEnabled && hasOptions" :class="$style.field">
    <label :for="id">{{ opportunityLabel }}</label>
    <multiselect
      :id="id"
      v-model="value"
      label="name"
      track-by="crmId"
      placeholder="Please select"
      :allow-empty="true"
      :show-labels="true"
      :options="opportunities"
      select-label=""
      selected-label="✕"
      deselect-label="✕"
    >
      <template #noResult>
        <span>No matches found</span>
      </template>
      <template #option="props">
        <div class="primary">{{ props.option.name }}</div>
        <div class="secondary" v-if="props.option.value">
          {{ props.option.value }}
          <font-awesome-icon v-if="props.option.won" :icon="trophyIcon" />
        </div>
      </template>
    </multiselect>
    <p v-show="error && showError">{{ error }}</p>
  </div>
</template>

<script>
import axios, { CancelToken } from "axios";
import Multiselect from "vue-components/vue-multiselect";
import { faTrophy } from "@fortawesome/pro-light-svg-icons/faTrophy";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { createNamespacedHelpers } from "vuex";
import { errorNotification } from "../notifications";

const { mapState, mapGetters, mapMutations } =
  createNamespacedHelpers("activitySummary");
let cancellationSource;

export default {
  components: { Multiselect, FontAwesomeIcon },
  data() {
    return {
      id: "opportunity_id",
      value: null,
      opportunities: [],
      crmName: this.$_activitySummary_config.getTeam().crm.name,
      trophyIcon: faTrophy,
    };
  },
  computed: {
    ...mapGetters(["opportunityEnabled", "hasSelectedOpportunity"]),
    ...mapState([
      "activity",
      "formErrors",
      "selectedProspect",
      "selectedOpportunity",
    ]),
    hasOptions() {
      return this.opportunities.length > 0;
    },
    error() {
      return this.formErrors[this.id];
    },
    opportunityLabel() {
      if (this.crmName === "Salesforce") {
        return "Opportunity";
      } else if (this.crmName === "HubSpot") {
        return "Deal";
      } else if (this.crmName === "Pipedrive") {
        return "Deal";
      } else if (this.crmName === "Copper") {
        return "Opportunity";
      } else if (this.crmName === "Close") {
        return "Opportunity";
      } else if (this.crmName === "Bullhorn") {
        return "Job Order";
      }
    },
  },
  watch: {
    value(option) {
      this.updateForm(option);
    },
    selectedProspect() {
      this.value = null;
      this.retrieveOpportunities();
    },
    selectedOpportunity(opportunity) {
      // Selected opportunity could be set externally via activity.opportunity-updated event
      if (opportunity) {
        this.value = opportunity;
        if (!this.opportunities.find((o) => o.crmId === opportunity.crmId)) {
          this.opportunities.push(opportunity);
        }
      }
    },
  },
  created() {
    this.$_activitySummary_config.EventBus.$on(
      "ACTIVITY_FORM_SUBMITTED",
      () => {
        this.showError = true;
      }
    );

    this.handleOpportunity();
    this.retrieveOpportunities();
  },
  methods: {
    ...mapMutations(["upsertFormData", "setSelectedOpportunity"]),
    handleOpportunity() {
      if (this.activity.opportunity) {
        this.value = this.activity.opportunity;
      }
    },
    updateForm(option) {
      this.showError = false;

      const opportunityId = option ? option.crmId : null;

      this.upsertFormData({
        id: this.id,
        value: opportunityId,
      });
      // If selected opportunity is null and a value is picked from the dropdown
      // or the selected value is different from the new value.
      if (
        !this.selectedOpportunity ||
        (this.selectedOpportunity &&
          this.selectedOpportunity.crmId !== opportunityId)
      ) {
        this.setSelectedOpportunity(option);
      }
    },
    retrieveOpportunities() {
      if (!this.opportunityEnabled) {
        return;
      }

      const key =
        this.selectedProspect.type === "contact" ? "contactId" : "accountId";

      if (cancellationSource) {
        cancellationSource.cancel();
      }
      cancellationSource = CancelToken.source();

      axios
        .get(
          `${this.$_activitySummary_config.jiminnyHost()}/api/v1/crm/opportunity`,
          {
            cancelToken: cancellationSource.token,
            params: {
              [key]: this.selectedProspect.crmId,
            },
          }
        )
        .then((response) => {
          this.opportunities =
            response.data && response.data.length > 0 ? response.data : [];
          if (
            this.activity.opportunity &&
            !this.opportunities.find(
              (o) => o.crmId === this.activity.opportunity.crmId
            )
          ) {
            this.opportunities.push(this.activity.opportunity);
          }

          if (
            !this.hasSelectedOpportunity &&
            this.opportunities &&
            this.opportunities.length > 0
          ) {
            this.value = this.opportunities[0];
          }
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            return;
          }

          console.error(error);

          errorNotification({
            message: error.response.data.error.message,
          }).show();
        });
    },
  },
};
</script>

<style module lang="less" src="../custom-section/fields/field.less"></style>



// WEBPACK FOOTER //
// select-opportunity.vue?55b8e74c